<div class="row" [formGroup]="formGroup">
  <div class="col-12 col-md-6 d-flex flex-row justify-content-between align-items-start">
    <input type="hidden" formControlName="type">
    <input type="hidden" formControlName="label">
    <mat-form-field class="w-25 me-3" appearance="fill" color="primary">
      <mat-label>Label</mat-label>
      <input type="text"
        placeholder="Pick one"
        matInput
        [formControl]="internalFormControl"
        [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
        @for (option of displayTypes; track option) {
          <mat-option [value]="option">
            {{option}}
          </mat-option>
        }
      </mat-autocomplete>
      @if (formGroup.get('type')?.invalid && formGroup.get('type')?.touched) {
        <mat-error>Type is required.</mat-error>
      }
      @if (formGroup.get('label')?.invalid && formGroup.get('label')?.touched) {
        <mat-error>Label is required.</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="flex-spacer" appearance="fill" color="primary">
      <mat-label>Address</mat-label>
      <textarea matInput formControlName="address" appInputFormatter [formatPattern]="'auto'" rows="6"></textarea>
      @if (formGroup.get('address')?.hasError('required')) {
        <mat-error>Address is required.</mat-error>
      }
    </mat-form-field>
    @if (showDelete) {
      <button mat-icon-button (click)="deleteItem()"><mat-icon>delete</mat-icon></button>
    }
  </div>
</div>
